import { GenIcon } from '../helpers/IconBase.es.js';

const BagCheckmarkOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M13 20.938C12.6683 20.9791 12.3343 20.9998 12 21C10.22 21 8.47991 20.4722 6.99987 19.4832C5.51983 18.4943 4.36628 17.0887 3.68509 15.4442C3.0039 13.7996 2.82567 11.99 3.17294 10.2442C3.5202 8.49836 4.37737 6.89472 5.63604 5.63604C6.89472 4.37737 8.49836 3.5202 10.2442 3.17294C11.99 2.82567 13.7996 3.0039 15.4442 3.68509C17.0887 4.36628 18.4943 5.51983 19.4832 6.99987C20.4722 8.47991 21 10.22 21 12C21 12.334 20.98 12.668 20.938 13",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21 18L18.5 20.5L17 19",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.459 9.25H8.541C8.24221 9.25 8 9.49221 8 9.791V15.709C8 16.0078 8.24221 16.25 8.541 16.25H15.459C15.7578 16.25 16 16.0078 16 15.709V9.791C16 9.49221 15.7578 9.25 15.459 9.25Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.5748 9.25V8.325C13.5748 7.90728 13.4089 7.50668 13.1135 7.21131C12.8181 6.91594 12.4175 6.75 11.9998 6.75C11.5821 6.75 11.1815 6.91594 10.8861 7.21131C10.5907 7.50668 10.4248 7.90728 10.4248 8.325V9.25",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { BagCheckmarkOutlined };
